import { AlertCircle } from "lucide-react";
import { cn } from "@shared-kernel/primary/shared/shadcn/utils/utils";
import type { ErrorStateProps } from "../types";

const DEFAULT_TITLE = "Une erreur est survenue";
const DEFAULT_DESCRIPTION = "Veuillez réessayer ultérieurement.";

export const ErrorState = ({ title = DEFAULT_TITLE, description = DEFAULT_DESCRIPTION, className }: ErrorStateProps) => {
  return (
    <div className={cn("flex min-h-[50vh] w-full flex-col items-center justify-center gap-3 text-center", className)}>
      <AlertCircle className="size-10 text-destructive" />
      <div className="space-y-1">
        <h3 className="text-lg font-semibold">{title}</h3>
        <p className="text-sm text-muted-foreground">{description}</p>
      </div>
    </div>
  );
};
